import { useNavigate } from 'react-router-dom';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, Button, SxProps, Theme, Typography } from '@mui/material';

const STRINGS = appStrings.modules.survey.output.ctas.areYouOnTrack;

export const AreYouOnTrackCTA = () => {
  const navigate = useNavigate();

  return (
    <Box sx={containerSx}>
      <Box component="img" src="/images/are-you-on-track-nugget-image.png" alt="" sx={imageSx} />
      <Box sx={contentSx}>
        <Box sx={textSx}>
          <Typography
            variant="text-md-semibold"
            color={({ backrs }) => backrs.colors['Colors/Text/text-primary']}
          >
            {STRINGS.title}
          </Typography>
          <Typography
            variant="text-sm-regular"
            color={({ backrs }) => backrs.colors['Colors/Text/text-tertiary']}
          >
            {STRINGS.description}
          </Typography>
        </Box>
        <Button
          id="blueprint-are-you-on-track-cta-btn"
          variant="contained"
          size="md"
          hierarchy="Primary"
          onClick={() => navigate(APP_ROUTE.ASSESS_MY_TRACK)}
          sx={actionBtnSx}
        >
          {STRINGS.action}
        </Button>
      </Box>
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  border: `1px solid ${backrs.colors['Colors/Foreground/fg-secondary']}`,
  borderRadius: backrs.radius['radius-xl'],
  overflow: 'hidden',
  backgroundColor: backrs.colors['Colors/Base/White'],
  '@container (min-width: 600px)': {
    flexDirection: 'row',
    alignItems: 'stretch',
  },
});

const imageSx: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  maxHeight: '157px',
  objectFit: 'cover',
  backgroundColor: backrs.colors['Colors/Base/Black'],
  flexShrink: 0,
  borderBottom: `1px solid ${backrs.colors['Colors/Base/Black']}`,
  '@container (min-width: 600px)': {
    width: '220px',
    height: 'auto',
    maxHeight: 'none',
    borderBottom: 'none',
    borderRight: `1px solid ${backrs.colors['Colors/Base/Black']}`,
  },
});

const contentSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: backrs.spacing['spacing-2xl'],
  padding: backrs.spacing['spacing-3xl'],
});

const textSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xxs'],
});

const actionBtnSx: SxProps<Theme> = {
  alignSelf: 'stretch',
  '@container (min-width: 600px)': {
    alignSelf: 'auto',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
};
